export default "__VITE_ASSET__DOjvPKz0__"